import React, { useCallback, useRef } from 'react'

export type FilePickerNewFile = {
  file: File
  valid: boolean
  error: unknown
}

export const FilePicker: React.FC<{
  accept?: string
  className?: string
  value?: File[]
  onChange(files?: FilePickerNewFile[]): void
  multiple?: boolean
  appendMode?: boolean
  render(props: { onClick(): void; files?: File[]; addAllowed: boolean }): React.ReactNode
  fileValidator?: (file: File) => Promise<unknown | null>
  addAllowed?: boolean
}> = ({
  render,
  className,
  multiple = false,
  value,
  onChange,
  accept,
  appendMode = false,
  addAllowed = true,
  fileValidator,
}) => {
  const ref = useRef<HTMLInputElement>(null)
  const onClick = useCallback(() => {
    if (ref.current && addAllowed) {
      ref.current.click()
    }
  }, [addAllowed])
  const handleChange = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      let items: File[] = []
      if (appendMode) {
        items = [...(value || []), ...(e.target.files || [])]
      } else {
        items = e.target.files ? Array.from(e.target.files) : []
      }

      let result: FilePickerNewFile[] = items.map(file => {
        return {
          file,
          valid: true,
          error: null,
        }
      })
      if (fileValidator) {
        const validationResults: unknown[] = await Promise.all(items.map(fileValidator))
        result = []
        validationResults.forEach((error, i) => {
          result.push({
            file: items[i],
            valid: !error,
            error,
          })
        })
      }
      onChange(result.length ? result : undefined)
    },
    [appendMode, fileValidator, onChange, value],
  )
  return (
    <div className={className}>
      {render({ onClick, files: value, addAllowed })}
      <input ref={ref} hidden type={'file'} onChange={handleChange} multiple={multiple} accept={accept} value="" />
    </div>
  )
}
